import { render, staticRenderFns } from "./BuyCertificate.vue?vue&type=template&id=60d01f36&scoped=true"
import script from "./BuyCertificate.vue?vue&type=script&lang=js"
export * from "./BuyCertificate.vue?vue&type=script&lang=js"
import style0 from "./BuyCertificate.vue?vue&type=style&index=0&id=60d01f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d01f36",
  null
  
)

export default component.exports